import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Form from '../views/pages/form';
import List from '../views/pages/list';
import Detail from '../views/pages/detail';
import PageNotFound from '../views/pages/404';

function Routes(){
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Form} />
        <Route path="/tttaaabbb" exact component={List} />
        <Route path="/detail/:id" exact component={Detail} />
        <Route path="*">
          <Route path='*' exact component={PageNotFound} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;